import katanautCapsule from './images/capsules/katanaut.png';
import katanautBanner from './images/banners/katanaut.jpg';
import steamLogo from './images/logos/steam.webp';

// Storefront/console badges shown under each capsule. Add entries here as
// platforms are confirmed; src/images/logos already has gog, epicgames, ps4,
// ps5, switch, xboxone and seriesx ready to go.
export const PLATFORMS = {
  steam: { label: 'Steam', icon: steamLogo },
};

// Single source of truth for the capsules on the landing page.
//
// To add a game:
//   1. Drop a 600x900 capsule into src/images/capsules and import it here.
//   2. Add an entry below (order here is the order on the page).
//   3. Build its page component the same way Katanaut.js is built, and point
//      `path` at a route for it in App.js.
//
// A game with `capsule: null` renders the "?" placeholder instead of art.
//
// `steamUrl` and `pressHref` are per-game: the navbar only shows those links on
// that game's own pages, never on the studio landing page. Leave them null for
// a game that has neither yet.
const games = [
  {
    id: 'katanaut',
    title: 'Katanaut',
    path: '/katanaut',
    capsule: katanautCapsule,
    // Wide key art for the landing page. `capsule` is the 600x900 portrait art,
    // kept in case a storefront-style grid is wanted again.
    banner: katanautBanner,
    status: 'OUT NOW',
    platforms: ['steam'],
    // Katanaut shipped, so the store button must not say "wishlist".
    ctaLabel: 'BUY NOW',
    steamUrl: 'https://store.steampowered.com/app/3032830?utm_source=site',
    pressHref: '/katanaut/press-kit',
  },
  {
    id: 'othercrown',
    title: 'Othercrown',
    releaseWindow: 'Q1 2027',
    path: '/othercrown',
    capsule: null,
    banner: null,
    status: 'IN DEVELOPMENT',
    platforms: [],
    ctaLabel: 'WISHLIST',
    steamUrl: 'https://store.steampowered.com/app/5217270?utm_source=site',
    pressHref: '/othercrown/press-kit',
  },
];

export function getGame(id) {
  return games.find((game) => game.id === id);
}

export default games;
